import axios from 'axios';
import { getAuthHeader } from '../../utils/tools';

export const fetchAdminStats = (params = {}) => {
    const query = new URLSearchParams(
        Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return axios.get(`/api/admin/stats${query ? `?${query}` : ''}`, getAuthHeader());
};

export const fetchAdminTenants = (params = {}) => {
    const query = new URLSearchParams(
        Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return axios.get(`/api/admin/tenants${query ? `?${query}` : ''}`, getAuthHeader());
};

export const fetchAdminTenantById = (id) =>
    axios.get(`/api/admin/tenants/${id}`, getAuthHeader());

export const setAdminTenantBlocked = (id, blocked) =>
    axios.patch(`/api/admin/tenants/${id}/block`, { blocked }, getAuthHeader());

export const setAdminTenantOwner = (id, userId) =>
    axios.patch(`/api/admin/tenants/${id}/owner`, { userId }, getAuthHeader());

export const extendAdminTenantLicense = (id, payload) =>
    axios.post(`/api/admin/tenants/${id}/extend`, payload, getAuthHeader());

export const deleteAdminManualPayment = (tenantId, paymentId) =>
    axios.delete(`/api/admin/tenants/${tenantId}/payments/${paymentId}`, getAuthHeader());

export const fetchAdminAdminLogs = (params = {}) => {
    const query = new URLSearchParams(
        Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return axios.get(`/api/admin/admin-logs${query ? `?${query}` : ''}`, getAuthHeader());
};

export const fetchAdminActivityLogs = (params = {}) => {
    const query = new URLSearchParams(
        Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return axios.get(`/api/admin/logs${query ? `?${query}` : ''}`, getAuthHeader());
};

export const fetchAdminSales = (params = {}) => {
    const query = new URLSearchParams(
        Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''))
    ).toString();
    return axios.get(`/api/admin/sales${query ? `?${query}` : ''}`, getAuthHeader());
};

export const fetchAdminUsers = (params = {}) => {
    const query = new URLSearchParams(
        Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== '' && v !== false))
    ).toString();
    return axios.get(`/api/admin/users${query ? `?${query}` : ''}`, getAuthHeader());
};

export const fetchAdminUserById = (id) =>
    axios.get(`/api/admin/users/${id}`, getAuthHeader());

export const updateAdminUser = (id, payload) =>
    axios.patch(`/api/admin/users/${id}`, payload, getAuthHeader());

export const fetchCronLogs = () =>
    axios.get('/api/admin/cron/logs', getAuthHeader());

export const runCronDryRun = () =>
    axios.get('/api/admin/cron/dry-run', getAuthHeader());

export const runCron = (password) =>
    axios.post('/api/admin/cron/run', { password }, getAuthHeader());
